import { makeStateStore } from '@playcastdotio/StateStore';
import type { BeaconInputConfig, BeaconState } from './types';
import { DEFAULT_BEACON_INPUT_CONFIG } from './types';

export type BeaconStores = {
  beacon: ReturnType<typeof makeStateStore<BeaconState>>;
};

export function createBeaconStores(): BeaconStores {
  return {
    beacon: makeStateStore<BeaconState>({
      shareCode: null,
      shareLink: null,
      streamTitle: '',
      currentPlayers: 0,
      maxPlayers: 4,
      inputConfig: { ...DEFAULT_BEACON_INPUT_CONFIG },
      previewEnabled: false,
    }),
  };
}
